
import debounce from 'lodash/debounce';
import { mmMatches } from '../utils/utils.matchmedia';
import Siema from 'siema';

function activateCounter(index) {
    const testimonialCarouselCounters = document.querySelectorAll('.js-testimonial-carousel-counter');

    // Remove the 'is-active' class for whichever counter is currently active.
    [...testimonialCarouselCounters].forEach(counter => {
        if(counter.classList.contains('is-active')) {
            counter.classList.remove('is-active');
        }

        // Add 'is-active' class to the slide that we just changed to.
        if(counter.getAttribute('data-controls-slide') == index) {
            counter.classList.add('is-active');
        }
    });
}

function setHeightOfCurrentItem(carousel) {
    carousel.sliderFrame.style.overflow = 'hidden';
    carousel.sliderFrame.style.height = carousel.innerElements[carousel.currentSlide].clientHeight + 'px';
}

function disableButton(button) {
	if(button) {
		button.classList.add('is-disabled');
		button.disabled = true;
	}
}

function enableButton(button) {
	if(button) {
		button.classList.remove('is-disabled');
		button.disabled = false;
	}
}

const 	testimonialCarousel = [...document.querySelectorAll('.js-testimonials-carousel')];

testimonialCarousel.forEach( item => {

    const   carouselList = item.querySelector('.js-carousel-list'),
            carouselChildren = carouselList.children,
            testimonialCountersEl = document.querySelector('.js-testimonial-carousel-counters'),
            prevButton = item.querySelector('.js-prev'),
            nextButton = item.querySelector('.js-next');

    if ( carouselChildren.length <= 1 ) {
        return false;
    }

	const carousel = new Siema({
		selector: carouselList,
		duration: 200,
		easing: 'ease-out',
		perPage: 1,
		startIndex: 0,
		draggable: true,
		multipleDrag: true,
		threshold: 20,
		loop: false,
		onInit: () => {
            item.classList.add('is-carousel');

            disableButton(prevButton);

			// Grab all the carousel items.
			const testimonialCarouselItems = item.querySelectorAll('.js-testimonial-carousel-item');

            // Loop through the slides and create a counter for each slide.
            for (let i = 0; i < testimonialCarouselItems.length; i++) {
                let testimonialCarouselCounter = document.createElement('li');
                testimonialCarouselCounter.classList.add('testimonials__counter');
                testimonialCarouselCounter.classList.add('js-testimonial-carousel-counter');
                testimonialCarouselCounter.setAttribute('data-controls-slide', i);

                if(i == 0) {
                    testimonialCarouselCounter.classList.add('is-active');
                }

                testimonialCountersEl.appendChild(testimonialCarouselCounter);
            }
        },
        onChange: () => {
            activateCounter(carousel.currentSlide);

            const numberOfSlides = carousel.innerElements.length;

            if(carousel.currentSlide > 0) {
				enableButton(prevButton);
			} else {
				disableButton(prevButton);
			}

			if(carousel.currentSlide + 1 == numberOfSlides) {
				disableButton(nextButton);
			} else {
				enableButton(nextButton);
			}

            // set height to current slide height
            setHeightOfCurrentItem(carousel);
        }
    });

    prevButton.addEventListener('click', e => {
        carousel.prev()
    });
    nextButton.addEventListener('click', e => {
        carousel.next()
    });

    carousel.sliderFrame.style.overflow = 'hidden';
    setHeightOfCurrentItem(carousel);

    // Grab all the counters that were created.
    const testimonialCarouselCounters = document.querySelectorAll('.js-testimonial-carousel-counter');

    window.addEventListener('resize', debounce( (e) => {
        setHeightOfCurrentItem(carousel);
    }, 20 ));

    // Loop through the counters and add an event listener to go to the selected slide.
    [...testimonialCarouselCounters].forEach((counter, i) => {
        counter.addEventListener('click', () => {
            carousel.goTo(i, () => activateCounter(i));
        });
    });
});
